export default __webpack_public_path__ + "static/media/slot8.102dfd97.png";